/* src/app/expense-item/feature/expense-item-feature.component.scss */
/*# sourceMappingURL=expense-item-feature.component.css.map */
